var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.image) ? _c('h4', {
    staticClass: "mb2 lh-title menu-title-section white"
  }, [_vm._v(_vm._s(_vm._f("preposFix")(_vm.title)))]) : _vm._e(), _vm._v(" "), (_vm.image) ? _c('img', {
    staticClass: "img-responsive center pb4",
    attrs: {
      "src": _vm.image,
      "alt": _vm.title
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu-section overflow-hidden"
  }, [_c('div', {
    staticClass: "menu-holder menu-accordion menu-no-imgs"
  }, [_vm._t("default")], 2)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a5b2792","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuCategory.vue
// module id = 105
// module chunks = 1